const LOCAL_STORAGE_KEY = 'user-location'

export function setCacheUserLocation(location) {
  const expiration = new Date().getTime() + 30 * 60 * 1000
  window.localStorage.setItem(
    LOCAL_STORAGE_KEY,
    JSON.stringify({ ...location, expiration })
  )
}

export function getCacheUserLocation() {
  const storage = window.localStorage.getItem(LOCAL_STORAGE_KEY)
  return storage ? JSON.parse(storage) || {} : {}
}

export function clearCacheUserLocation() {
  window.localStorage.removeItem(LOCAL_STORAGE_KEY)
}
